export const auth = {
    register: null,
    login: null
}